// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const NudgeButtonContainer = styled.span`
  margin-left: 15px;
`;
